import { useEffect, useRef } from 'react'
import { useStore } from 'zustand'
import { type NoiseSuppressionStatus, noiseStatusStore } from '@/shared/lib/livekit'
import { toast } from '@/shared/ui/toast'
import { useNoiseSuppression } from './noise-store'

// Фактическое состояние обработки (не пользовательский тумблер): что реально
// происходит с AudioWorklet-процессором на микрофонном треке.
export function useNoiseStatus(): NoiseSuppressionStatus {
  return useStore(noiseStatusStore, (s) => s.status)
}

// Железная гарантия «включился и работает»: переход в failed/unsupported
// показывается тостом — молчаливых падений шумодава нет.
export function useNoiseFailureToast(): void {
  const status = useNoiseStatus()
  const enabled = useNoiseSuppression((s) => s.enabled)
  const reported = useRef<NoiseSuppressionStatus | null>(null)

  useEffect(() => {
    if (!enabled) {
      reported.current = null
      return
    }
    if (status === reported.current) return
    if (status === 'failed') {
      reported.current = status
      toast.error('Шумоподавление не включилось: звук идёт без обработки')
    } else if (status === 'unsupported') {
      reported.current = status
      toast.error('Шумоподавление не поддерживается этим устройством')
    } else if (status === 'active') {
      // Восстановился — позволяем сообщить о следующем падении.
      reported.current = null
    }
  }, [status, enabled])
}
